<template>
  <div class="meter-manufacturer-total">
    <div class="fixed">
      <div class="header-item">{{ $t('厂家名称') }}</div>
      <div class="header-item">{{ $t('水表总数') }}</div>
      <div class="header-item">{{ $t('远传/非远传') }}</div>
      <div class="header-item">{{ $t('传输方式') }}</div>
    </div>
    <div class="list-container">
      <div class="list-scroll">
        <div class="list-row" v-for="(item, index) in list" :key="index">
          <div class="list-item manufacturer-name">{{ item.name }}</div>
          <div class="list-item manufacturer-count">{{ item.num }}</div>
          <div class="list-item manufacturer-type">{{ item.isYc }}</div>
          <div class="list-item manufacturer-transmission">{{ item.type }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postAction } from '@/api/manage'

export default {
  name: 'MeterManufacturerTotal',
  data() {
    return {
      title: this.$t('水表厂家情况汇总'),
      list: [],
      url: {
        list: "/jeecg-charge/meter/meterReadingLargeScreen/queryLargeScreenMeterFactory"
      },
      pageNo: 1,
      pageSize: -10,
      errorNum: 0
    }
  },
  // mounted() {
  //   this.init()
  // },
  methods: {
    init() {
      this.resetData()
      this.getData()
    },
    
    resetData() {
      this.list = []
    },
    
    getData() {
      this.list = []
      postAction(this.url.list, {}).then(res => {
        if (res.success) {
          if (res.result && res.result.xdata) {
            // 只取前4个厂家，避免重复和抽搐
            // const maxItems = Math.min(4, res.result.xdata.length)
            // for (let i = 0; i < maxItems; i++) {
            //   this.list.push({
            //     name: res.result.xdata[i],
            //     num: res.result.ydata[i]?.num || 0,
            //     isYc: '远传',
            //     type: 'NB-IOT'
            //   })
            // }
            res.result.xdata.map((item,index)=>{
              this.list.push({
                name:item,
                num: res.result.ydata[index].num,
                isYc: this.$t('远传'),
                type: 'NB-IOT'
              })
            })
            // 如果数据不足4个，用实际数据填充，不要用mock数据重复
            if (this.list.length === 0) {
              this.list = this.getMockData().slice(0, 4)
            }
          }
        } else {
          this.list = this.getMockData().slice(0, 4)
        }
      }).catch(() => {
        this.list = this.getMockData().slice(0, 4)
      })
    },
    
    getMockData() {
      return [
        { name: '宁波水表', num: 4268, isYc: '远传', type: 'NB-IOT' },
        { name: '三川智慧', num: 3187, isYc: '远传', type: 'NB-IOT' },
        { name: '新天科技', num: 2894, isYc: '远传', type: 'NB-IOT' },
        { name: '华旭科技', num: 2135, isYc: '远传', type: 'NB-IOT' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.meter-manufacturer-total {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.fixed {
  display: flex;
  align-items: center;
  background-color: #08306F;
  color: #FFF;
  height: 30px;
}

.header-item {
  width: 25%;
  text-align: center;
}

.list-container {
  flex: 1;
  overflow: hidden;
  min-height: 0;
  padding: 5px;
}

.list-scroll {
  height: 100%;
  overflow-y: auto;
  padding-right: 5px;
}

.list-scroll::-webkit-scrollbar {
  width: 4px;
}

.list-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.list-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 168, 255, 0.3);
  border-radius: 2px;
}

.list-row {
  color: #fff;
  display: flex;
  align-items: center;
  padding: 8px 5px;
  margin-bottom: 2px;
  background: rgba(0, 168, 255, 0.1);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.list-row:hover {
  background: rgba(0, 168, 255, 0.2);
  transform: translateX(2px);
}

.list-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  color: #fff;
  font-size: 12px;
}

.manufacturer-name {
  width: 25%;
  // text-align: left;
  // padding-left: 8px;
  font-weight: 500;
}

.manufacturer-count {
  width: 25%;
  color: #00a8ff;
  font-weight: bold;
}

.manufacturer-type {
  width: 25%;
}

.manufacturer-transmission {
  width: 25%;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 1200px) {
  .meter-manufacturer-total {
    padding: 0;
  }
}
</style>